window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.TutorBotVoiceAgent = window.locales.am.TutorBotVoiceAgent || {};window.locales.am.TutorBotVoiceAgent.audioControlBar = window.locales.am.TutorBotVoiceAgent.audioControlBar || {};window.locales.am.TutorBotVoiceAgent.audioControlBar = {...window.locales.am.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "ውይይቱን ጨርስ",
    "mute": "ድምጸ-ከል አድርግ",
    "unmute": "አለመደሰት",
    "microphoneSelect": "ማይክሮፎን ይምረጡ",
    "audioDevice": "የድምጽ መሳሪያ",
    "default": "ነባሪ",
    "output": "ውፅዓት",
    "input": "ግቤት",
    "audioSelect": "ኦዲዮ ይምረጡ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.TutorBotVoiceAgent = window.locales.ar.TutorBotVoiceAgent || {};window.locales.ar.TutorBotVoiceAgent.audioControlBar = window.locales.ar.TutorBotVoiceAgent.audioControlBar || {};window.locales.ar.TutorBotVoiceAgent.audioControlBar = {...window.locales.ar.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "انهاء المناقشة",
    "mute": "صامت",
    "unmute": "استياء",
    "microphoneSelect": "اختيار الميكروفون",
    "audioDevice": "جهاز صوتي",
    "default": "تقصير",
    "output": "الناتج",
    "input": "مدخل",
    "audioSelect": "اختيار الصوت"
}
};window.locales.en = window.locales.en || {};window.locales.en.TutorBotVoiceAgent = window.locales.en.TutorBotVoiceAgent || {};window.locales.en.TutorBotVoiceAgent.audioControlBar = window.locales.en.TutorBotVoiceAgent.audioControlBar || {};window.locales.en.TutorBotVoiceAgent.audioControlBar = {...window.locales.en.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "End discussion",
    "mute": "Mute",
    "unmute": "Unmute",
    "microphoneSelect": "Microphone select",
    "audioDevice": "Audio Device",
    "default": "Default",
    "output": "Output",
    "input": "Input",
    "audioSelect": "Audio select"
}
};window.locales.es = window.locales.es || {};window.locales.es.TutorBotVoiceAgent = window.locales.es.TutorBotVoiceAgent || {};window.locales.es.TutorBotVoiceAgent.audioControlBar = window.locales.es.TutorBotVoiceAgent.audioControlBar || {};window.locales.es.TutorBotVoiceAgent.audioControlBar = {...window.locales.es.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "Fin de la discusión",
    "mute": "Silenciar",
    "unmute": "disgusto",
    "microphoneSelect": "Seleccionar micrófono",
    "audioDevice": "Dispositivo de audio",
    "default": "Por defecto",
    "output": "Producción",
    "input": "Aporte",
    "audioSelect": "Selección de audio"
}
};window.locales.it = window.locales.it || {};window.locales.it.TutorBotVoiceAgent = window.locales.it.TutorBotVoiceAgent || {};window.locales.it.TutorBotVoiceAgent.audioControlBar = window.locales.it.TutorBotVoiceAgent.audioControlBar || {};window.locales.it.TutorBotVoiceAgent.audioControlBar = {...window.locales.it.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "Termina la discussione",
    "mute": "Muto",
    "unmute": "dispiacere",
    "microphoneSelect": "Selezione microfono",
    "audioDevice": "Dispositivo audio",
    "default": "Predefinito",
    "output": "Produzione",
    "input": "Ingresso",
    "audioSelect": "Selezione audio"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.TutorBotVoiceAgent = window.locales.zh.TutorBotVoiceAgent || {};window.locales.zh.TutorBotVoiceAgent.audioControlBar = window.locales.zh.TutorBotVoiceAgent.audioControlBar || {};window.locales.zh.TutorBotVoiceAgent.audioControlBar = {...window.locales.zh.TutorBotVoiceAgent.audioControlBar, ...{
    "endDiscussion": "结束讨论",
    "mute": "沉默的",
    "unmute": "不快",
    "microphoneSelect": "麦克风选择",
    "audioDevice": "音频设备",
    "default": "默认",
    "output": "输出",
    "input": "输入",
    "audioSelect": "音频选择"
}
};